import Route from '@ember/routing/route';

export default class MarketRevenueInsightBreakdownDetailRoute extends Route {
  queryParams = {
    segmentationId: {
      refreshModel: true,
    },
    activeTab: {
      refreshModel: true,
    },
  };
}
